import axios from 'axios';

// Define your base URL here
const BASE_URL = `${process.env.REACT_APP_API_URL}/api/tourist-centers`; // Update with your actual base URL

// Function to create a new tourist center
export const createTouristCenter = async (touristCenterData) => {
  try {
    const response = await axios.post(BASE_URL + '/create', touristCenterData, {
      headers: {
        'Content-Type': 'multipart/form-data' // Important for file uploads
      }
    });
    return response.data; // Return the created tourist center
  } catch (error) {
    console.error('Error creating tourist center:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Function to get all tourist centers
export const getTouristCenters = async () => {
  try {
    const response = await axios.get(BASE_URL + '/all');
    return response.data; // Return the list of tourist centers
  } catch (error) {
    console.error('Error fetching tourist centers:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Function to get a single tourist center by ID
export const getTouristCenterById = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data; // Return the tourist center
  } catch (error) {
    console.error('Error fetching tourist center:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Function to update a tourist center by ID
export const updateTouristCenter = async (id, touristCenterData) => {
  try {
    const response = await axios.put(`${BASE_URL}/update/${id}`, touristCenterData, {
      headers: {
        'Content-Type': 'multipart/form-data' // Important for file uploads
      }
    });
    return response.data; // Return the updated tourist center
  } catch (error) {
    console.error('Error updating tourist center:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Function to delete a tourist center by ID
export const deleteTouristCenter = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data; // Return the success message
  } catch (error) {
    console.error('Error deleting tourist center:', error);
    throw error; // Re-throw the error for handling in the component
  }
};